export default __webpack_public_path__ + "static/media/HomeBackground.7bd79135.png";